import { List, Map, Set } from 'immutable'
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Action,
  any,
  async,
  AsyncState,
  browserRouter,
  Fun,
  HttpResult,
  IOWidget,
  loadingAsyncState,
  mk_pair,
  mk_widget,
  none,
  nothing,
  Option,
  Pair,
  some,
  unloadedAsyncState,
  Widget,
  onlyIf,
  loadedAsyncState,
  mkWidget
} from 'widgets-for-react'
import {
  ContentType,
  defaultPage,
  emptyAppState,
  FooterState,
  HeaderState,
  PublicSiteState
} from '../../public_site.main.mod'
import { BlocksRenderer } from '../cms/blocks/block_to_widget.gen'
import { Page } from '../cms/page/types.gen'
import { CustomRouteParams, ExtraParameters } from '../cms/router/type.gen'
import { AppState, PageTemplateState } from '../cms/state/types.gen'
import { PageStateZero } from '../cms/state/utils.gen'
import { EntryClient } from '../cms/widget.gen'
import * as Api from '../drupal/api/api.mod'
import { loadPrivacyMenu, loadTopMenu, parse_menu, loadCountryMenu, loadTags } from '../drupal/api/api.mod'
import { DrupalBlock_To_WidgetBlock, parseImage, TransformStandardBlock } from '../drupal/drupal_to_cms.mod'
import { GetDrupalBlockImagesLoaders } from '../drupal/rendering/image_utils.mod'
import { CustomBlock } from '../drupal/types_and_parser/custom_blocks.mod'
import {
  Breadcrumb,
  ParsedMenuItem,
  MenuItem,
  CustomParsedNode,
  Language
} from '../drupal/types_and_parser/extra_types.mod'
import { Block } from '../drupal/types_and_parser/standard_blocks.gen'
import { ParsedNode, ParsedParagraph, ParsedNodeStory } from '../drupal/types_and_parser/types'
import { CustomParsedEntity } from '../drupal/types_and_parser/extra_types.mod'
import { Locale } from '../drupal/types_and_parser/extra_types.mod'
import { BatchRequestResponse, performBatchRequest } from '../http_batch'
import { CustomBlockData } from './blocks/custom_blocks/types.mod'
import { pageDisplay } from './blocks/renderer.mod'
import { CustomPages, vacancyCountryTags, vacancyDepartmentTags, overview_tag_to_taxonomy_title, PublicSiteCustomRoutes } from './custom_pages/types.mod'
import { ExtraImages, get_default_data_srcset, get_default_data_src, extra_images, quotesblock_src, quotesblock_srcset } from './utils/extra_images.mod'
import { getLangFromUrl, localizeMenu } from './utils/history.mod'
import { convertEmToPx } from './templates/header.mod'
import { getVacancyIdFromUrl, removeBoldsAndSplitsButLastSplit, titleSplit } from './utils/helpers'
import { t } from 'i18next'
import { hubspotIframeBlockClasses, textBlockClasses, textImageClasses, expandBlockClasses, reportClasses, ctaBlockClasses, gridHighlightBlockClasses, factsAndFiguresBlockClasses, customSpacerBlockClasses, quotesBlockClasses, latestUpdatesBlockClasses } from './blocks/style.mod'
import { GetCookiebarContent, GetCookiebarButton } from '../drupal/rendering/cookiebar_utils.mod'

import { PressReleaseItem } from './blocks/custom_blocks/widgets/pressReleasesBlock'
import { expandProps } from './blocks/custom_blocks/widgets/expandBlock.mod'
import { formBlockProps, formBlockStyle } from './blocks/custom_blocks/widgets/formBlock'
import { getFormState } from '../form/api'
import { linkWrapper } from '../cms/blocks/utils.gen'
import { ctaBlockProps } from './blocks/custom_blocks/widgets/ctaBlock.mod'
import { closeJobPostingDiv } from './custom_pages/pages/vacancyDetailPage/vacancy_detail'
import { reset_prev_tags } from './custom_pages/pages/overviewPage/overview_page'
import { factsAndFiguresBlockProps } from './blocks/custom_blocks/widgets/factsAndFiguresBlock.mod'
import { customSpacerBlockProps } from './blocks/custom_blocks/widgets/customSpacerBlock.mod'
// import { featuredContentBlockProps } from './blocks/custom_blocks/widgets/featuredContentBlock.mod'
import { quoteItemBlockProps, quotesBlockProps } from './blocks/custom_blocks/widgets/quotesBlock.mod'
import { timelineItem } from './blocks/custom_blocks/widgets/timelineBlock.mod'
import { latestUpdateItemBlockProps, latestUpdatesBlockProps } from './blocks/custom_blocks/widgets/latestUpdatesBlock.mod'
import React = require('react')
import { ParadoxLoader } from './paradoxLoader'

export type PublicSite_CustomPageData = {
  node: CustomParsedNode
  extra_params?: ExtraParameters
  breadcrumb: AsyncState<List<Breadcrumb>>
  homepage_departments: AsyncState<string[]>
  homepage_countries: AsyncState<string[]>
}

export const InitPagesStates: (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
) => PageTemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState> = (
  b
) => ({
  page: PageStateZero<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState>(
    () => unloadedAsyncState(),
    defaultPage,
    pageDisplay(b)
  ).page
})
export let add_project_title = (title: string) => {
  let title1 = title.toLowerCase().split(' ').join('')
  if (!title1?.startsWith("stone-")) {
    title = "STONE - Interim & Detacheren - " + title.replace(/%/g, "")
  }
  return title
}
export function updateMetaDescription(desc: string) {
  var elem = document.querySelector('meta[name="description"]')
  if (!elem) {
    elem = document.createElement('meta')
    document.getElementsByTagName('head')[0].appendChild(elem)
    elem.setAttribute('name', 'description')
  }
  elem.setAttribute('content', desc)
}
export const getDrupalLanguage = (l: Locale): Language => (
  l == 'be_nl'
    ? 'nl'
    : l == 'be_fr'
      ? 'fr'
      : l == 'na-fr'
        ? 'fr'
        : l == 'na-es'
          ? 'es'
          : l == 'fr'
            ? 'fr'
            : l == 'pl'
              ? 'pl'
              : l == 'fi'
                ? 'fi'
                : l == 'es'
                  ? 'es'
                  : l == 'it'
                    ? 'it'
                    : l == 'de'
                      ? 'de'
                      : l == 'nl'
                        ? 'nl'
                        : 'en'
)

export const getPage = (
  slug: string,
  extra_parameters: ExtraParameters
): AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>> =>
  loadingAsyncState((_) =>
    Api.GetDrupalNode(slug)
      .then<HttpResult<Page<CustomBlock, Block, PublicSite_CustomPageData>>>((page: HttpResult<CustomParsedEntity> & { is_preview: boolean }) => {
        if (page.kind != "result") {
          return { kind: 'failed', status: 404 }
        }
        if (page.value.entity_type != "node") {
          return { kind: 'failed', status: 404 }
        }
        let breadcrumbs: AsyncState<List<Breadcrumb>> = loadedAsyncState(List())
        if (!page.is_preview) {
          breadcrumbs = Api.loadBreadcrumbs(page.value.language_links.get(page.value.language), getLangFromUrl())
        }
        return {
          kind: 'result',
          value: {
            blocks: (page.value.field_page_content as List<ParsedParagraph>)
              .map((b: ParsedParagraph) => TransformStandardBlock(b))
              .toArray(),
            extra_data: {
              node: {
                ...page.value,
                is_preview: page.is_preview
              },
              extra_params: extra_parameters,
              breadcrumb: breadcrumbs,
              homepage_departments: loadTags("vacancy-overview", getDrupalLanguage(getLangFromUrl()), overview_tag_to_taxonomy_title(vacancyDepartmentTags), Map()),
              homepage_countries: loadTags("vacancy-overview", getDrupalLanguage(getLangFromUrl()), overview_tag_to_taxonomy_title(vacancyCountryTags), Map())
            }
          },
          status: 200
        }
      })
      .catch((e) => {
        console.error("This error occurred in getPage:", e)
        return e
      })
  )
let is_batch_call_running = false

export let departments: string[] = []
export let countries: string[] = []

export const application = (
  data: { rootpath: string; rootpath_to_ignore: string; login_address?: string },
  header: (_: HeaderState) => Widget<Action<HeaderState>>,
  productdetailpageHeader: (_: HeaderState) => Widget<Action<HeaderState>>,
  footer: (_: FooterState) => Widget<Action<FooterState>>,
  errorPage: IOWidget<PublicSiteState, never>,
  loadingPage: Widget<never>,
  page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode | CustomParsedNode>>, ContentType>,
  custom_pages: CustomPages
) => {
  const rootpath = data.rootpath ? data.rootpath : ''
  const rootpath_to_ignore = data.rootpath_to_ignore ? data.rootpath_to_ignore : ''

  return (s0: AppState<PublicSiteState, PublicSiteCustomRoutes>) => {
    if (s0.state.page.custom_page_data.v.kind == "r" && s0.state.page.custom_page_data.v.v.homepage_departments.kind == "loaded") {
      departments = s0.state.page.custom_page_data.v.v.homepage_departments.value
    }
    if (s0.state.page.custom_page_data.v.kind == "r" && s0.state.page.custom_page_data.v.v.homepage_countries.kind == "loaded") {
      countries = s0.state.page.custom_page_data.v.v.homepage_countries.value
    }
    return browserRouter<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()(
      s0.route.kind == 'ignore'
        ? nothing()
        : any<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()([
          mkWidget({ run: () => <ParadoxLoader /> }),
          s0.state.batch_get_header_footer.kind == 'unloaded'
            ? mk_widget({
              run: (set_state: (output: Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>) => void) => {
                const lang = s0.state.header.currentLanguage
                const batch_get_header_footer: AsyncState<BatchRequestResponse[]> = loadingAsyncState(
                  () =>
                    new Promise<HttpResult<BatchRequestResponse[]>>((res, _) => {
                      if (is_batch_call_running) return res({ kind: 'unauthorized', status: 400 })
                      is_batch_call_running = true
                      const localePart = lang === 'global' ? '' : `/${lang}`
                      performBatchRequest([
                        {
                          requests: [
                            {
                              method: 'GET',
                              path: `/api/drupal${localePart}/api/menu_items/main`,
                              requestId: 'header'
                            },
                            {
                              method: 'GET',
                              path: `/api/drupal${localePart}/api/menu_items/footer`,
                              requestId: 'footer'
                            },
                            // { method: 'GET', path: `/api/drupal${localePart}/api/available_languages`, requestId: 'languages' },
                            {
                              method: 'GET',
                              path: `/api/drupal${localePart}/api/menu_items/main`,
                              requestId: 'top_menu'
                            },
                            {
                              method: 'GET',
                              path: `/api/drupal${localePart}/api/menu_items/footer`,
                              requestId: 'privacy_menu'
                            }
                          ],
                          success: async (res) => {
                            set_state((s) => {
                              const s1 = { ...s }

                              const header_req = res.find((r) => r.requestId == 'header')
                              if (header_req && header_req.data.kind == 'result') {
                                const header_list: List<ParsedMenuItem> = parse_menu(
                                  JSON.parse(header_req.data.value)
                                )
                                s1.state.header.menuHeader.navLinks = {
                                  kind: 'loaded',
                                  value: header_list,
                                  cache: { kind: 'empty' }
                                }
                              }

                              const footer_req = res.find((r) => r.requestId == 'footer')
                              if (footer_req && footer_req.data.kind == 'result') {
                                let menuItems = JSON.parse(footer_req.data.value) as MenuItem[]
                                menuItems = localizeMenu(menuItems, lang)
                                const footer_list: List<ParsedMenuItem> = parse_menu(menuItems)
                                s1.state.footer.menu = {
                                  kind: 'loaded',
                                  value: footer_list,
                                  cache: { kind: 'empty' }
                                }
                              }

                              const languages_req = res.find((r) => r.requestId == 'languages')
                              if (languages_req && languages_req.data.kind == 'result') {
                                const languages_list: List<string> = List(
                                  Object.keys(JSON.parse(languages_req.data.value))
                                )
                                s1.state.header.menuHeader.languages = {
                                  kind: 'loaded',
                                  value: languages_list,
                                  cache: { kind: 'empty' }
                                }
                              }

                              const top_menu_req = res.find((r) => r.requestId == 'top_menu')
                              if (top_menu_req && top_menu_req.data.kind == 'result') {
                                const top_menu_list: List<ParsedMenuItem> = parse_menu(
                                  JSON.parse(top_menu_req.data.value)
                                )
                                s1.state.header.topMenu = {
                                  kind: 'loaded',
                                  value: top_menu_list,
                                  cache: { kind: 'empty' }
                                }
                              }

                              const country_menu_req = res.find((r) => r.requestId == 'country_menu')
                              if (country_menu_req && country_menu_req.data.kind == 'result') {
                                const country_menu_list: List<ParsedMenuItem> = parse_menu(
                                  JSON.parse(country_menu_req.data.value)
                                )
                                s1.state.header.countryMenu = {
                                  kind: 'loaded',
                                  value: country_menu_list,
                                  cache: { kind: 'empty' }
                                }
                              }

                              const privacy_menu_req = res.find((r) => r.requestId == 'privacy_menu')
                              if (privacy_menu_req && privacy_menu_req.data.kind == 'result') {
                                const privacy_menu_list: List<ParsedMenuItem> = parse_menu(
                                  JSON.parse(privacy_menu_req.data.value)
                                )
                                s1.state.footer.privacyMenu = {
                                  kind: 'loaded',
                                  value: privacy_menu_list,
                                  cache: { kind: 'empty' }
                                }
                              }

                              return s1
                            })
                          },
                          error: async (res) => {
                            set_state((s) => {
                              const s1 = { ...s }

                              const headerReq = res.find((r) => r.requestId == 'header')
                              if (headerReq && headerReq.data.kind == 'result') {
                                const headerList: List<ParsedMenuItem> = parse_menu(
                                  JSON.parse(headerReq.data.value)
                                )
                                s1.state.header.menuHeader.navLinks = {
                                  kind: 'loaded',
                                  value: headerList,
                                  cache: { kind: 'empty' }
                                }
                              } else {
                                s1.state.header.menuHeader.navLinks = loadingAsyncState(() => Api.loadHeader(lang))
                              }

                              const footerReq = res.find((r) => r.requestId == 'footer')
                              if (footerReq && footerReq.data.kind == 'result') {
                                const footerList: List<ParsedMenuItem> = parse_menu(
                                  JSON.parse(footerReq.data.value)
                                )
                                s1.state.footer.menu = {
                                  kind: 'loaded',
                                  value: footerList,
                                  cache: { kind: 'empty' }
                                }
                              } else {
                                s1.state.footer.menu = loadingAsyncState(() => Api.loadFooter(lang))
                              }

                              // const languages_req = res.find((r) => r.requestId == 'languages')
                              // if (languages_req && languages_req.data.kind != 'result') {
                              //   s1.state.header.menuHeader.languages = loadingAsyncState(() => Api.loadLanguages())
                              // }

                              const top_menu_req = res.find((r) => r.requestId == 'top_menu')
                              if (top_menu_req && top_menu_req.data.kind != 'result') {
                                s1.state.header.topMenu = loadingAsyncState(() => loadTopMenu(lang))
                              }

                              const country_menu_req = res.find((r) => r.requestId == 'top_menu')
                              if (country_menu_req && country_menu_req.data.kind != 'result') {
                                s1.state.header.countryMenu = loadingAsyncState(() => loadCountryMenu(lang))
                              }

                              const privacy_menu_req = res.find((r) => r.requestId == 'privacy_menu')
                              if (privacy_menu_req && privacy_menu_req.data.kind != 'result') {
                                s1.state.footer.privacyMenu = loadingAsyncState(() => loadPrivacyMenu(lang))
                              }

                              return s1
                            })
                          }
                        }
                      ])
                        .then((_res) => res({ kind: 'result', status: 200, value: _res }))
                        .catch((e) => {
                          console.log('Error calling batch', e)
                          res({ kind: 'failed', status: 400 })
                        })
                    })
                )
                set_state((s) => {
                  return { ...s, state: { ...s.state, batch_get_header_footer } }
                })
                return null
              }
            })
            : nothing(),

          onlyIf((s0.state.header.topMenu.kind == 'unloaded' &&
            s0.state.header.countryMenu.kind == 'unloaded' &&
            s0.state.header.menuHeader.navLinks.kind == 'unloaded' &&
            s0.state.footer.menu.kind == 'unloaded' &&
            s0.state.footer.privacyMenu.kind == 'unloaded'
          ), mk_widget({
            run: (set_state: (output: Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>) => void) => {
              const lang = s0.state.header.currentLanguage
              let s1 = s0

              if (s1.state.header.topMenu.kind == 'unloaded') {
                s1.state.header.topMenu = loadingAsyncState(() => loadTopMenu(lang))
              }
              if (s1.state.header.countryMenu.kind == 'unloaded') {
                s1.state.header.countryMenu = loadingAsyncState(() => loadCountryMenu(lang))
              }
              if (s1.state.header.menuHeader.navLinks.kind == 'unloaded') {
                s1.state.header.menuHeader.navLinks = loadingAsyncState(() => Api.loadHeader(lang))
              }
              if (s1.state.footer.menu.kind == 'unloaded') {
                s1.state.footer.menu = loadingAsyncState(() => Api.loadFooter(lang))
              }
              if (s1.state.footer.privacyMenu.kind == 'unloaded') {
                s1.state.footer.privacyMenu = loadingAsyncState(() => loadPrivacyMenu(lang))
              }

              set_state(() => {
                return s0
              })

              return null
            }
          })),


          async<BatchRequestResponse[]>((_) => nothing())(s0.state.batch_get_header_footer).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >((a) => (s1) => ({
            ...s1,
            state: { ...s1.state, batch_get_header_footer: a(s1.state.batch_get_header_footer) }
          })),

          s0.state.page.custom_page_data.v.kind == "r" ? async<string[]>((_) => nothing())(s0.state.page.custom_page_data.v.v.homepage_departments).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>((a) => (s1) => (s1.state.page.custom_page_data.v.kind == "l" ? s1 : {
            ...s1, state: {
              ...s1.state, page: {
                ...s1.state.page, custom_page_data:
                  some({
                    ...s1.state.page.custom_page_data.v.v,
                    homepage_departments: a(s1.state.page.custom_page_data.v.v.homepage_departments)
                  })
              }
            }
          })) : nothing(),

          s0.state.page.custom_page_data.v.kind == "r" ? async<string[]>((_) => nothing())(s0.state.page.custom_page_data.v.v.homepage_countries).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>((a) => (s1) => (s1.state.page.custom_page_data.v.kind == "l" ? s1 : {
            ...s1, state: {
              ...s1.state, page: {
                ...s1.state.page, custom_page_data:
                  some({
                    ...s1.state.page.custom_page_data.v.v,
                    homepage_countries: a(s1.state.page.custom_page_data.v.v.homepage_countries)
                  })
              }
            }
          })) : nothing(),

          async<List<ParsedMenuItem>>((_) => nothing())(s0.state.header.menuHeader.navLinks).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >((a) => (s1) => ({
            ...s1,
            state: {
              ...s1.state,
              header: {
                ...s1.state.header,
                menuHeader: {
                  ...s1.state.header.menuHeader,
                  navLinks: a(s1.state.header.menuHeader.navLinks)
                }
              }
            }
          })),
          async<List<string>>((_) => nothing())(s0.state.header.menuHeader.languages).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >((a) => (s1) => {
            return {
              ...s1,
              state: {
                ...s1.state,
                header: {
                  ...s1.state.header,
                  menuHeader: {
                    ...s1.state.header.menuHeader,
                    languages: a(s1.state.header.menuHeader.languages)
                  }
                }
              }
            }
          }),
          async<List<ParsedMenuItem>>((_) => nothing())(s0.state.footer.menu).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >((a) => (s1) => ({
            ...s1,
            state: {
              ...s1.state,
              footer: {
                ...s1.state.footer,
                menu: a(s1.state.footer.menu)
              }
            }
          })),
          async<List<ParsedMenuItem>>((_) => nothing())(s0.state.footer.privacyMenu).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >((a) => (s1) => ({
            ...s1,
            state: {
              ...s1.state,
              footer: {
                ...s1.state.footer,
                privacyMenu: a(s1.state.footer.privacyMenu)
              }
            }
          })),

          async<List<ParsedMenuItem>>((_) => nothing())(s0.state.header.topMenu).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >((a) => (s1) => ({
            ...s1,
            state: {
              ...s1.state,
              header: {
                ...s1.state.header,
                topMenu: a(s1.state.header.topMenu)
              }
            }
          })),

          async<List<ParsedMenuItem>>((_) => nothing())(s0.state.header.countryMenu).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >((a) => (s1) => ({
            ...s1,
            state: {
              ...s1.state,
              header: {
                ...s1.state.header,
                countryMenu: a(s1.state.header.countryMenu)
              }
            }
          })),

          s0.state.page.page.kind == 'loaded' && s0.state.page.page.value.extra_data.node.bundle != 'homepage'
            ? async<List<Breadcrumb>>((_) => nothing())(s0.state.page.page.value.extra_data.breadcrumb).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >((a) => (s1) => {
              if (s1.state.page.page.kind == 'loaded') {
                const a1 = a(s1.state.page.page.value.extra_data.breadcrumb)

                s1 = {
                  ...s1,
                  state: {
                    ...s1.state,
                    page: {
                      ...s1.state.page,
                      display: page(
                        mk_pair(
                          a1.kind == 'loaded' ? a1.value : List(),
                          some(s1.state.page.page.value.extra_data.node)
                        )
                      ),
                      page: {
                        ...s1.state.page.page,
                        value: {
                          ...s1.state.page.page.value,
                          extra_data: {
                            ...s1.state.page.page.value.extra_data,
                            breadcrumb: a1
                          }
                        }
                      }
                    }
                  }
                }
              }
              return s1
            })
            : nothing(),

          s0.route.kind == 'styleguide' || s0.route.kind == 'selectLocale'
            ? nothing()
            : header(s0.state.header).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>((a) => (s1) => ({
              ...s1,
              state: { ...s1.state, header: a(s1.state.header) }
            })),

          EntryClient<
            CustomBlockData,
            CustomBlock,
            Block,
            PublicSiteState,
            keyof CustomPages,
            PublicSiteCustomRoutes,
            ExtraImages,
            PublicSite_CustomPageData
          >({
            initState: emptyAppState(page),
            custom_pages,
            StandardBlockImagesLoader: GetDrupalBlockImagesLoaders,
            StandardBlock_To_Widget: DrupalBlock_To_WidgetBlock,
            errorPage: errorPage,
            loadingPage: loadingPage,
            rootpath: rootpath,
            rootpath_to_ignore: rootpath_to_ignore,
            CustomBlock_To_Widget: CustomBlock_To_Widget,
            CustomBLockImagesLoader: (c: CustomBlock) => {
              if (c.kind == 'personBlock') {
                //let img = mk_pair(c.image, loadMedia(c.image) as AsyncState<Map<ImageSize<ExtraImages>, Url>>)
                //improve when personBlock is ready in drupal/parsed_types
                return []
              }
              return []
            }
          })(s0).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>((a) => (s) => {
            let s1 = a(s)
            if (s.state.page.page.kind != 'loaded' && s1.state.page.page.kind == 'loaded') {
              s1 = {
                ...s1,
                state: {
                  ...s1.state,
                  page: {
                    ...s1.state.page,
                    display: page(mk_pair(List(), some(s1.state.page.page.value.extra_data.node)))
                  }
                }
              }
            }

            if (s1.route != s0.route) {
              s1.state.header.mode == 'closed'
            }

            if (window.innerWidth < convertEmToPx(64)) {
              document.documentElement.classList.toggle('nav--toggled', s1.state.header.mode == 'open')
            } else {
              document.documentElement.classList.remove('nav--toggled')
            }

            return s1
          }),

          onlyIf(
            s0.route.kind != 'styleguide' && s0.route.kind != 'selectLocale',
            footer(s0.state.footer).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>((a) => (s1) => ({
              ...s1,
              state: { ...s1.state, footer: a(s1.state.footer) }
            }))
          )
          // history().map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(la => {
          //   la.action == 'PUSH' && window.scrollTo(0, 0)

          //   return s1 => ({
          //     ...s1,
          //     state: {
          //       ...s1.state,
          //       header: {
          //         ...s1.state.header,
          //         mode: 'closed'
          //       }
          //     }
          //   })
          // })
        ])
    ).map<AppState<PublicSiteState, PublicSiteCustomRoutes>>((a) => {
      const s1 = a(s0)
      // if (s1.route.kind == '404' || s1.route.kind == 'ignore' || s0.route.kind == '404' || s0.route.kind == 'ignore') {
      //   window.scrollTo(0, 0)
      // }

      const lang = getLangFromUrl()
      if (s1.state.header.currentLanguage != lang) {
        s1.state.header.currentLanguage = lang
        s1.state.batch_get_header_footer = unloadedAsyncState()
      }
      if (s0.state.page.page.kind != 'loaded' && s1.state.page.page.kind == 'loaded') {
        s1.state.header.node = s1.state.footer.node = s1.state.page.page.value.extra_data.node
      }
      if (s1.state.page.page.kind == 'failed' && s0.state.page.page.kind != 'failed') {
        s1.state.header.node = s1.state.footer.node = 'none'
      }

      s1.state.page.page.kind == 'loaded' &&
        (window.document.title = removeBoldsAndSplitsButLastSplit(
          s1.state.page.page.value.extra_data.node.metatag.title
        ))
      s1.route.kind == 'selectLocale' && (window.document.title = t('SelectLocale:titleBrowserTab'))
      s1.route.kind == 'requestDocuments' && (window.document.title = t('BimAndDrawingsForm:Texts.BrowserTab'))
      s1.route.kind == 'story_overview' && (window.document.title = `${s1.route.slug} | Refresco`)

      if (shouldScroll(s0.route, s1.route)) {
        reset_prev_tags()
        closeJobPostingDiv()
        s1.state.header.mode = 'closed'
        window.scrollTo(0, 0)
      }

      if (
        (s1.route.kind == 'search_overview' && s1.route.slug == "search") ||
        (s1.route.kind == 'overview' && s1.route.slug == "vacancies") || 
        (s1.route.kind == 'press') ||
        (s1.route.kind == 'vacancyItem') || 
        (s1.state.header.node != "none" && s1.state.header.node.bundle == 'story')
        ) {
        s1.state.header.isTransparent = false
      } else {
        s1.state.header.isTransparent = true
      }

      window.document.body.setAttribute('data-menustate', s1.state.header.mode)
      return s1
    })
  }
}

const shouldScroll = (r0: CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, r1: CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>): boolean => {
  if (r0.kind == "overview" && r1.kind == "overview") {
    return r0.slug != r1.slug
  }

  return r1 != r0
}

export const CustomBlock_To_Widget = (c: CustomBlock, block_index: number): Option<CustomBlockData> => {
  if (c.kind == 'personBlock') {
    return some({
      kind: 'personBlock',
      value: mk_pair(
        {
          block_index: block_index,
          name: c.value.name,
          role: 'whatever'
        },
        {}
      )
    })
  } else if (c.kind == 'form') {
    const vacancyIdOption = getVacancyIdFromUrl()
    return some({
      kind: 'formBlock',
      value: mk_pair<formBlockProps, formBlockStyle>(
        {
          block_index,
          form_id: c.field_form_list,
          state: getFormState([], c.field_form_list, vacancyIdOption.v.kind == 'r' ? vacancyIdOption.v.v : '')
        },
        {}
      )
    } as CustomBlockData)
  } else if (c.kind == 'quote') {
    return some({
      kind: 'quoteBlock',
      value: mk_pair(
        {
          blockIndex: block_index,
          quote: c.field_quote,
          person: c.field_author_name,
          function: c.field_function,
          background: c.field_background,
          primaryButton: c.field_links.isEmpty() || c.field_links.count() <= 1
            ? undefined
            : linkWrapper(c.field_links.get(0)),
          secondaryButton: c.field_links.isEmpty() || c.field_links.count() <= 1
            ? undefined
            : linkWrapper(c.field_links.get(1)),
          errors: Map(),
          push: undefined,
          submit: unloadedAsyncState()
        },
        {}
      )
    })
  } else if (c.kind == 'press_releases') {
    return some({
      kind: 'pressReleasesBlock',
      value: mk_pair(
        {
          blockIndex: block_index,
          item_limit: c.field_item_limit,
          show_year_filter: c.field_show_year_filter,
          button: !c.field_button ? undefined : linkWrapper(c.field_button),
          press_releases: loadingAsyncState(() => Api.GetPressReleases<PressReleaseItem>())
        },
        {}
      )
    })
  } else if (c.kind == 'media') {
    return some({
      kind: 'mediaBlock',
      value: mk_pair(
        {
          blockIndex: block_index,
          media: c.field_media,
          caption: c.field_caption,
          background: c.field_background,
          errors: Map(),
          push: undefined,
          submit: unloadedAsyncState(),
          useCookieBar: true,
          cookiePlaceholder: GetCookiebarContent('media'),
          cookieButton: GetCookiebarButton('media'),
          get_default_data_srcset: get_default_data_srcset,
          get_default_data_src: get_default_data_src
        },
        {}
      )
    })
  } else if (c.kind == 'stories_grid') {
    return some({
      kind: 'storiesBlock',
      value: mk_pair(
        {
          block_index,
          title: c.field_title,
          link: !c.field_link ? undefined : linkWrapper(c.field_link),
          stories: loadingAsyncState(() => Api.GetOverview<ParsedNodeStory>("stories-overview", getLangFromUrl())),
          errors: Map(),
          push: undefined,
          submit: unloadedAsyncState()
        },
        {}
      )
    })
  } else if (c.kind == 'timeline') {
    return some({
      kind: 'timelineBlock',
      value: mk_pair(
        {
          blockIndex: block_index,
          title: c.field_title,
          introduction: c.field_introduction,
          items: c.field_items.map(item => ({
            title: item.field_title,
            introduction: item.field_introduction,
            media: item.field_media,
            field_image: item.field_timeline_background_image ? item.field_timeline_background_image : undefined,
            image: item.field_timeline_background_image ? parseImage(item.field_timeline_background_image) : undefined,
            image_alt:
              item.field_timeline_background_image && item.field_timeline_background_image.field_media_image.alt ? item.field_timeline_background_image.field_media_image.alt : '',
            image_size: '600x600',
          }) as timelineItem).toList(),
          errors: Map(),
          push: undefined,
          submit: unloadedAsyncState()
        },
        {}
      )
    })
  } else if (c.kind == 'text_with_image') {
    return some({
      kind: 'textImageBlock',
      value: mk_pair(
        {
          blockIndex: block_index,
          imageLocation: c.field_featured_content_direction == 'image_left' ? 'left' : 'right',
          field_image: c.field_image ? c.field_image : undefined,
          image: c.field_image ? parseImage(c.field_image) : undefined,
          image_alt:
            c.field_image && c.field_image.field_media_image.alt ? c.field_image.field_media_image.alt : '',
          text: c.field_text,
          backgroundImage: c.field_image_background ? c.field_image_background : undefined,
          title: c.field_title,
          introduction: c.field_body,
          label: c.field_label,
          errors: Map(),
          push: undefined,
          primary_button: c.field_links.isEmpty()
            ? undefined
            : linkWrapper(c.field_links.get(0)),
          secondary_button: c.field_links.isEmpty() || c.field_links.count() <= 1
            ? undefined
            : linkWrapper(c.field_links.get(1)),
          submit: unloadedAsyncState(),
          get_default_data_srcset: get_default_data_srcset,
          get_default_data_src: get_default_data_src
        },
        textImageClasses(c.field_featured_content_direction == 'image_left' ? 'left' : 'right')
      )
    })
  } else if (c.kind == 'hubspot_form') {
    return some({
      kind: 'hubspotIFrameBlock',
      value: mk_pair(
        {
          index: block_index,
          useCookieBar: true,
          cookiePlaceholder: GetCookiebarContent('iframe'),
          cookieButton: GetCookiebarButton('iframe'),
          inview: {
            threshold: 0.1,
            triggerOnce: true
          },
          inputfields: {
            portalID: c.field_portal_id,
            formID: c.field_form_id
          }
        },
        hubspotIframeBlockClasses
      )
    })
  } else if (c.kind == 'text') {
    return some({
      kind: 'textBlock',
      value: mk_pair(
        {
          index: block_index,
          title: c.field_title,
          text: c.field_body,
          primary_button: c.field_links.isEmpty()
            ? undefined
            : linkWrapper(c.field_links.get(0)),
          link: c.field_links.isEmpty() || c.field_links.count() <= 1
            ? undefined
            : linkWrapper(c.field_links.get(1)),
          link_type: false,
          background: c.field_background,
          inview: {
            threshold: 0.1,
            triggerOnce: true
          },
        },
        textBlockClasses
      )
    })
  } else if (c.kind == 'grid_highlight') {
    return some({
      kind: 'gridHighlightBlock',
      value: mk_pair(
        {
          index: block_index,
          title: c.field_title,
          text: c.field_introduction,
          link: c.field_link,
          field_highlight_items: c.field_highlight_items.toArray()
        },
        gridHighlightBlockClasses
      )
    })
  } else if (c.kind == 'expandable_content_blocks') {
    return some({
      kind: 'expandBlock',
      value: mk_pair(
        {
          index: block_index,
          title: c.field_title,
          intro: c.field_introduction,
          items: c.field_expandable_content_blocks
            .filter((x) => x !== undefined)
            .map<expandProps<CustomBlockData, ExtraImages>>((e, i) => ({
              key: `${block_index}-${i}`,
              index: block_index,
              title: e!.field_title,
              text: e!.field_body,
              links: e!.field_link_list,
              downloads: e!.field_downloads,
              open: false,
              useSVGIcons: true
            }))
            .toArray(),
          link: !c.field_link ? undefined : linkWrapper(c.field_link),
          inview: {
            threshold: 0.1,
            triggerOnce: true
          },
        },
        expandBlockClasses
      )
    })
  } else if (c.kind == 'reports_overview') {
    return some({
      kind: 'reportsBlock',
      value: mk_pair(
        {
          block_index: block_index,
          field_tabs: c.field_tabs,
          current_tab: 0
        },
        reportClasses
      )
    })
  } else if (c.kind == 'cta') {
    console.log(c)
    return some(
      {
        kind: 'ctaBlock',
        value: mk_pair(
          {
            title: c.field_title ? titleSplit(c.field_title) : '',
            intro: c.field_introduction,
            primary_button: c.field_link
              ? c.field_link && linkWrapper(c.field_link)
              : undefined,
            link_type: false,
            field_image: c.field_image ? c.field_image : undefined,
            image: c.field_image ? parseImage(c.field_image) : undefined,
            image_alt:
              c.field_image && c.field_image.field_media_image.alt ? c.field_image.field_media_image.alt : '',
            image_size: '640w',
            text_color: "white",
            get_default_data_src,
            get_default_data_srcset,
            inview: {
              threshold: 0.1,
              triggerOnce: true
            }
          } as ctaBlockProps<ExtraImages>,
          ctaBlockClasses(!!c.field_image)
        )
      })
  } else if (c.kind == 'quotes') {
    return some(
      {
        kind: 'quotesBlock',
        value: mk_pair(
          {
            index: block_index,
            field_title: c.field_title,
            field_quote_items: c.field_quote_items
              .map((e, i) => ({
                field_author_name: e!.field_author_name,
                field_function: e!.field_function,
                field_link: e!.field_link,
                field_quote: e!.field_quote,
                field_image: e.field_image ? e.field_image : undefined,
                image: e.field_image ? parseImage(e.field_image) : undefined,
                image_alt:
                  e.field_image && e.field_image.field_media_image.alt ? e.field_image.field_media_image.alt : '',
                image_size: '450x450',

              }) as quoteItemBlockProps)
              .toList(),
            inview: {
              threshold: 0.1,
              triggerOnce: true
            }

          } as quotesBlockProps,
          quotesBlockClasses(true)
        )
      })
  } else if (c.kind == 'latest_updates_block') {
    return some(
      {
        kind: 'latestUpdatesBlock',
        value: mk_pair(
          {
            index: block_index,
            field_title: c.field_title,
            field_latest_update_item: c.field_latest_update_item
              .map((e, i) => ({
                field_label: e!.field_label,
                field_link: e!.field_link,
                field_image: e.field_image ? e.field_image : undefined,
              }) as latestUpdateItemBlockProps)
              .toList(),
            inview: {
              threshold: 0.1,
              triggerOnce: true
            }
          } as latestUpdatesBlockProps,
          latestUpdatesBlockClasses(true)
        )
      })
  // } else if (c.kind == 'featured_content') {
  //   return some(
  //     {
  //       kind: 'featuredContentBlock',
  //       value: mk_pair(
  //         {
  //           index: block_index,
  //           title: c.field_title,
  //           intro: c.field_introduction,
  //           label: c.field_label,
  //           primaryButton: c.field_link
  //             ? c.field_link && linkWrapper(c.field_link)
  //             : undefined,
  //           link_type: false,
  //           field_image: c.field_image ? c.field_image : undefined,
  //           image: c.field_image ? parseImage(c.field_image) : undefined,
  //           image_alt:
  //             c.field_image && c.field_image.field_media_image.alt ? c.field_image.field_media_image.alt : '',
  //           image_size: '700w',
  //           image_position: c.field_image_position || "left",
  //           background_image: c.field_background_image || "water",
  //           inview: {
  //             threshold: 0.1,
  //             triggerOnce: true
  //           }
  //         } as featuredContentBlockProps<ExtraImages>,
  //         featuredContentBlockClasses(true)
  //       )
  //     })
  } else if (c.kind == 'facts_and_figures') {
    return some(
      {
        kind: 'factsAndFiguresBlock',
        value: mk_pair(
          {
            index: block_index,
            facts_and_figures_items: c.field_facts_and_figures_items,
            inview: {
              threshold: 0.1,
              triggerOnce: true
            }
          } as factsAndFiguresBlockProps,
          factsAndFiguresBlockClasses(false)
        )
      })
  } else if (c.kind == 'custom_spacer') {
    return some(
      {
        kind: 'customSpacerBlock',
        value: mk_pair(
          {
            index: block_index,
            inview: {
              threshold: 0.1,
              triggerOnce: true
            }
          } as customSpacerBlockProps,
          customSpacerBlockClasses(false)
        )
      })
  }
  return none()
}
